@if (showBreadcrumb()) {
  <nav class="breadcrumb" aria-label="Breadcrumb">
    <a
      class="breadcrumb-link"
      [routerLink]="tasksLink"
      [dataSelector]="'cxp-crl-page-header-breadcrumb-tasks'"
    >Tasks</a>
    <span class="breadcrumb-sep" aria-hidden="true">/</span>
    <span class="breadcrumb-current">{{ name() }}</span>
  </nav>
}

<h1 class="title" [dataSelector]="'cxp-crl-page-header-title'">{{ name() }}</h1>

@if (eyebrow(); as eyebrowText) {
  <div class="meta-row">
    <span class="client-name" [dataSelector]="'cxp-crl-page-header-eyebrow'">{{ eyebrowText }}</span>
  </div>
}

@if (description(); as text) {
  <div class="description-block">
    <p class="description" [class.description-expanded]="expanded()">
      <span [innerHTML]="text | sanitizedHtml"></span>
    </p>
    <button
      type="button"
      class="description-toggle"
      [dataSelector]="'cxp-crl-page-header-description-toggle'"
      (click)="toggleExpanded()"
    >{{ toggleLabel() }}</button>
  </div>
}
